const ProjectConfigAmenity = () => {
  return <div>ProjectConfigAmenity Page</div>;
};

export default ProjectConfigAmenity;
